import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import * as Styled from './my-library-empty-state.styled';
export const MyLibraryEmptyState = React.memo(function MyLibraryEmptyState() {
  const profileModel = useEdgeConfigWidget(WidgetId.Profile);
  return <Styled.Wrapper>
      <Styled.Icon />
      <Styled.Info>
        <Styled.Title>{profileModel.strings.myLibraryEmptyStateTitle}</Styled.Title>
        <Styled.Content html={profileModel.strings.myLibraryEmptyStateDescription} suppressHydrationWarning disableSanitization />
      </Styled.Info>
    </Styled.Wrapper>;
});